var e4 = e4 || {},
    eldorado = eldorado || {};
( function () {
    'use strict';
    eldorado.rma = {
        arrCaseLinesData: [],
        objCaseLinesData: {},
        classes: {
            strRmaCount: '.js-eldorado-rma-count',
            strRmaUnassignedProductsCount: '.js-eldorado-rma-unassigned-products-count',
            strRmaListPaginationPage: '.js-eldorado-rma-list-pagination-page',
            strRmaListPaginationDefaultPage: '.js-eldorado-rma-list-pagination-default-page',
            strRmaChangeUserModal: '.js-eldorado-rma-change-user-modal',
            strRmaChangeUserLink: '.js-eldorado-rma-change-user-link',
            strRmaCaseOverlay: '.js-eldorado-rma-case-overlay',
            strRmaCaseLines: '.js-eldorado-rma-case-lines',
            strRmaCaseLinesForm: '.js-eldorado-rma-case-lines-form',
            strRmaCaseLinesList: '.js-eldorado-rma-case-lines-list',
            strRmaCaseLinesApplyConsultantButton: '.js-eldorado-rma-case-lines-apply-consultant-button',
            strRmaCaseLinesApplyConsultantModal: '.js-eldorado-rma-case-lines-apply-consultant-modal',
            strRmaCaseLinesApplyConsultantModalForm: '.js-eldorado-rma-case-lines-apply-consultant-modal-form',
            strRmaCaseLinesApplyConsultantModalFormInputCaseId: '.js-eldorado-rma-case-lines-apply-consultant-modal-form-input-case-id',
            strRmaCaseLinesApplyConsultantModalFormInputCaseLineId: '.js-eldorado-rma-case-lines-apply-consultant-modal-form-input-case-line-id',
            strRmaCaseLinesApplyConsultantList: '.js-eldorado-rma-case-lines-apply-consultant-list',
            strRmaCases: '.js-eldorado-rma-cases',
            strRmaCasesForm: '.js-eldorado-rma-cases-form',
            strRmaCasesFormExternal: '.js-eldorado-rma-cases-form-external',
            strRmaCasesFormInternal: '.js-eldorado-rma-cases-form-internal',
            strRmaCasesList: '.js-eldorado-rma-cases-list',
            strRmaCaseDetailsResetButton: '.js-eldorado-rma-case-details-reset-button',
            strRmaCaseDetailsSaveButton: '.js-eldorado-rma-case-details-save-button',
            strRmaCaseDetailsCloseButton: '.js-eldorado-rma-case-details-close-button',
            strRmaCaseDetailsStatusSelector: '.js-eldorado-rma-case-details-status-selector',
            strRmaCaseDetailsReasonForRejectionModal: '.js-eldorado-rma-detail-reason-for-rejection-modal',
            strRmaCaseDetailsReasonForRejectionModalForm: '.js-eldorado-rma-detail-reason-for-rejection-modal-form',
            strRmaCaseDetailsReasonForRejectionModalSelect: '.js-eldorado-rma-detail-reason-for-rejection-modal-select',
            strRmaCaseDetailsReasonForRejectionModalTextArea: '.js-eldorado-rma-detail-reason-for-rejection-modal-text-area',
            strRmaCaseDetailsReasonForRejectionModalButtonCancel: '.js-eldorado-rma-detail-reason-for-rejection-modal-button-cancel',
            strRmaCaseDetailsReasonForRejectionModalButtonSubmit: '.js-eldorado-rma-detail-reason-for-rejection-modal-button-submit',
            strRmaCaseDetailsReasonForRejectionText: '.js-eldorado-rma-case-details-reason-for-rejection-text',
            strNewRmaCase: '.js-eldorado-new-rma-case',
            strNewRmaCaseConfirmButton: '.js-eldorado-new-rma-case-confirm-button',
            strNewRmaCaseConfirmCheckbox: '.js-eldorado-new-rma-case-confirm-checkbox',
            strNewRmaCaseLines: '.js-eldorado-new-rma-case-lines',
            strNewRmaCaseLinesDeleteButton: '.js-eldorado-new-rma-case-lines-delete-button',
            strNewRmaCaseLinesDeleteConfirmationModal: '.js-eldorado-new-rma-case-lines-delete-confirmation-modal',
            strNewRmaCaseLinesDeleteConfirmationModalForm: '.js-eldorado-new-rma-case-lines-delete-confirmation-modal-form',
            strNewRmaCaseLinesDeleteConfirmationModalFormInputCaseLineIndex: '.js-eldorado-new-rma-case-lines-delete-confirmation-modal-form-input-case-line-index',
            strNewRmaCaseLinesDeleteConfirmationModalFormInputCaseLineId: '.js-eldorado-new-rma-case-lines-delete-confirmation-modal-form-input-case-line-id',
            strNewRmaCaseModal: '.js-eldorado-new-rma-case-modal',
            strNewRmaCaseModalInitialAlert: '.js-eldorado-new-rma-case-modal-initial-alert',
            strNewRmaCaseModalStep1: '.js-eldorado-new-rma-case-modal-step-1',
            strNewRmaCaseModalStep2: '.js-eldorado-new-rma-case-modal-step-2',
            strNewRmaCaseModalCreateRmaLineForm: '.js-eldorado-new-rma-case-modal-create-rma-line-form',
            strNewRmaCaseModalCreateRmaLineFormButton: '.js-eldorado-new-rma-case-modal-create-rma-line-form-button',
            strNewRmaCaseModalOrderlinesInput: '.js-eldorado-new-rma-case-modal-orderlines-input',
            strNewRmaCaseModalOrderlinesInputButton: '.js-eldorado-new-rma-case-modal-orderlines-input-button',
            strNewRmaCaseModalOrderlinesResults: '.js-eldorado-new-rma-case-modal-orderlines-results',
            strNewRmaCaseModalOrderlinesResultsSelectButton: '.js-eldorado-new-rma-case-modal-orderlines-select-button',
            strNewRmaCaseModalOrderlinesResultsSelection: '.js-eldorado-new-rma-case-modal-orderlines-results-selection',
            strNewRmaCaseModalReceiptInput: '.js-eldorado-new-rma-case-modal-receipt-input',
            strNewRmaCaseModalReceiptInputHidden: '.js-eldorado-new-rma-case-modal-receipt-input-hidden',
            strNewRmaCaseModalImageInput: '.js-eldorado-new-rma-case-modal-image-input',
            strNewRmaCaseModalImageInputHidden: '.js-eldorado-new-rma-case-modal-image-input-hidden',
            strNewRmaCaseUploadReceiptModal: '.js-eldorado-new-rma-case-upload-receipt-modal',
            strNewRmaCaseUploadReceiptModalForm: '.js-eldorado-new-rma-case-upload-receipt-modal-form',
            strNewRmaCaseUploadReceiptModalFormSubmit: '.js-eldorado-new-rma-case-upload-receipt-modal-submit',
            strNewRmaCaseUploadReceiptModalFileInput: '.js-eldorado-new-rma-case-upload-receipt-modal-file-input',
            strNewRmaCaseUploadReceiptModalFileInputLabel: '.js-eldorado-new-rma-case-upload-receipt-modal-file-input-label',
            strNewRmaCaseUploadImageModal: '.js-eldorado-new-rma-case-upload-image-modal',
            strNewRmaCaseUploadImageModalForm: '.js-eldorado-new-rma-case-upload-image-modal-form',
            strNewRmaCaseUploadImageModalFormSubmit: '.js-eldorado-new-rma-case-upload-image-modal-submit',
            strNewRmaCaseUploadImageModalFileInput: '.js-eldorado-new-rma-case-upload-image-modal-file-input',
            strNewRmaCaseUploadImageModalFileInputLabel: '.js-eldorado-new-rma-case-upload-image-modal-file-input-label'
        },
        init: function () {
            if ( jQuery( eldorado.rma.classes.strNewRmaCaseModal ).length > 0 ) {
                e4.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-eldorado-new-rma-case-orderlines-results #js-e-handlebars-tmpl-eldorado-new-rma-case-orderlines-results-selection #js-e-handlebars-tmpl-eldorado-new-rma-case-lines' );
                    e4.require.js( e4.settings.require.jQueryValidate, function () {
                        eldorado.rma.validator.validationCustomRules();
                        eldorado.rma.validator.validatedForm = eldorado.rma.validator.validateForm( eldorado.rma.classes.strNewRmaCaseModalCreateRmaLineForm );
                        eldorado.rma.bindingsForRmaCreation();
                        jQuery( eldorado.rma.classes.strNewRmaCaseModal ).modal();
                        jQuery( eldorado.rma.classes.strNewRmaCaseModalOrderlinesInput ).focus();
                    } );
                } );
            }
            if ( jQuery( eldorado.rma.classes.strRmaCases ).length > 0 ) {
                e4.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-eldorado-rma-cases-list' );
                    eldorado.rma.bindingsForRmaCaseLists();
                    eldorado.rma.bindingsForRmaUserChange();
                    jQuery( eldorado.rma.classes.strRmaCases ).find( eldorado.rma.classes.strRmaCasesForm ).submit();
                } );
            }

            if ( jQuery( eldorado.rma.classes.strRmaCaseLines ).length > 0 ) {
                e4.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-eldorado-rma-case-lines-list #js-e-handlebars-tmpl-eldorado-rma-case-line-consultants' );
                    eldorado.rma.bindingsForRmaCaseLinesLists();
                    eldorado.rma.bindingsForRmaUserChange();
                    jQuery( eldorado.rma.classes.strRmaCaseLines ).find( eldorado.rma.classes.strRmaCaseLinesForm ).submit();
                } );
            }

            if ( jQuery( eldorado.rma.classes.strRmaCaseDetailsStatusSelector ).length > 0 ) {
                e4.require.js( e4.settings.require.jQueryValidate, function () {
                    eldorado.rma.validator.validationCustomRules();
                    eldorado.rma.validator.validatedForm = eldorado.rma.validator.validateForm( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModalForm );
                    eldorado.rma.bindingsForRmaProcessing();
                } );
            }
        },
        bindingsForRmaCreation: function () {
            jQuery( eldorado.rma.classes.strNewRmaCaseConfirmCheckbox ).on( 'change', function () {
                eldorado.rma.validator.validateNewCaseConfirmation();
            } );

            jQuery( eldorado.rma.classes.strNewRmaCaseConfirmButton ).on( 'click', function ( event ) {
                event.preventDefault();
                let strCaseUrl = jQuery( this ).data( 'case-url' ),
                    strCaseId = jQuery( this ).data( 'case-id' );
                eldorado.rma.handlers.confirmRmaCaseGet( strCaseUrl, strCaseId );
            } );

            jQuery( eldorado.rma.classes.strNewRmaCaseLinesDeleteConfirmationModal ).on( 'show.bs.modal', function ( event ) {
                jQuery( eldorado.rma.classes.strNewRmaCaseLinesDeleteConfirmationModal ).find( eldorado.rma.classes.strRmaCaseOverlay ).removeClass( 'is-loading' );
                let jRemoveButton = jQuery( event.relatedTarget );
                jQuery( this ).find( eldorado.rma.classes.strNewRmaCaseLinesDeleteConfirmationModalFormInputCaseLineIndex ).val( jRemoveButton.data( 'index' ) );
                jQuery( this ).find( eldorado.rma.classes.strNewRmaCaseLinesDeleteConfirmationModalFormInputCaseLineId ).val( jRemoveButton.data( 'line-id' ) );
            } );

            jQuery( eldorado.rma.classes.strNewRmaCaseLinesDeleteConfirmationModal ).on( 'submit', eldorado.rma.classes.strNewRmaCaseLinesDeleteConfirmationModalForm, function ( event ) {
                event.preventDefault();
                let intCaseLineIndex = jQuery( this ).find( eldorado.rma.classes.strNewRmaCaseLinesDeleteConfirmationModalFormInputCaseLineIndex ).val(),
                    strCaseLineId = jQuery( this ).find( eldorado.rma.classes.strNewRmaCaseLinesDeleteConfirmationModalFormInputCaseLineId ).val();
                eldorado.rma.handlers.deleteRmaLineFromCaseGet( intCaseLineIndex, strCaseLineId );
            } );

            jQuery( eldorado.rma.classes.strNewRmaCaseModal ).on( 'submit', eldorado.rma.classes.strNewRmaCaseModalCreateRmaLineForm, function ( event ) {
                event.preventDefault();
            } );

            jQuery( eldorado.rma.classes.strNewRmaCaseModal ).on( 'blur input', 'input:not(' + eldorado.rma.classes.strNewRmaCaseModalOrderlinesInput + ')', function ( event ) {
                jQuery( eldorado.rma.classes.strNewRmaCaseModalCreateRmaLineFormButton ).removeAttr( 'disabled' );
            } );

            jQuery( eldorado.rma.classes.strNewRmaCaseModal ).on( 'keypress', eldorado.rma.classes.strNewRmaCaseModalOrderlinesInput, e4.util.debounce( function ( event ) {
                event.preventDefault();
                if ( event.which === 13 ) {
                    eldorado.rma.search.orderlines.get( jQuery( event.target ).get( 0 ) );
                }
            }, e4.settings.debounceDelay.input ) );

            jQuery( eldorado.rma.classes.strNewRmaCaseModal ).on( 'click', eldorado.rma.classes.strNewRmaCaseModalOrderlinesInputButton, function () {
                eldorado.rma.search.orderlines.get( jQuery( eldorado.rma.classes.strNewRmaCaseModalOrderlinesInput ).get( 0 ) );
            } );

            jQuery( eldorado.rma.classes.strNewRmaCaseModal ).on( 'click', eldorado.rma.classes.strNewRmaCaseModalOrderlinesResultsSelectButton, function () {
                jQuery( eldorado.rma.classes.strNewRmaCaseModalStep1 ).addClass( 'd-none' );
                jQuery( eldorado.rma.classes.strNewRmaCaseModalStep2 ).removeClass( 'd-none' );
                jQuery( eldorado.rma.classes.strNewRmaCaseModalOrderlinesResultsSelection ).html( e4.handlebars.tmpl.eldoradoNewRmaCaseOrderlinesResultsSelection( eldorado.rma.search.orderlines.objData[ jQuery( this ).data( 'index' ) ] ) );
            } );
            jQuery( eldorado.rma.classes.strNewRmaCaseModal ).on( 'hide.bs.modal', function () {
                eldorado.rma.reset();
            } );
            jQuery( eldorado.rma.classes.strNewRmaCaseUploadReceiptModal ).on( 'change', eldorado.rma.classes.strNewRmaCaseUploadReceiptModalFileInput, function ( event ) {
                let strFileName = event.target.files[ 0 ].name;
                jQuery( eldorado.rma.classes.strNewRmaCaseUploadReceiptModalFileInputLabel ).html( strFileName ).removeClass( 'text-danger' );
                jQuery( eldorado.rma.classes.strNewRmaCaseUploadReceiptModalFormSubmit ).removeAttr( 'disabled' );
            } );
            jQuery( eldorado.rma.classes.strNewRmaCaseUploadReceiptModal ).on( 'submit', eldorado.rma.classes.strNewRmaCaseUploadReceiptModalForm, function ( event ) {
                event.preventDefault();
                eldorado.rma.upload.receiptPost( this );
            } );
            jQuery( eldorado.rma.classes.strNewRmaCaseUploadImageModal ).on( 'change', eldorado.rma.classes.strNewRmaCaseUploadImageModalFileInput, function ( event ) {
                let strFileName = event.target.files[ 0 ].name;
                jQuery( eldorado.rma.classes.strNewRmaCaseUploadImageModalFileInputLabel ).html( strFileName ).removeClass( 'text-danger' );
                jQuery( eldorado.rma.classes.strNewRmaCaseUploadImageModalFormSubmit ).removeAttr( 'disabled' );
            } );
            jQuery( eldorado.rma.classes.strNewRmaCaseUploadImageModal ).on( 'submit', eldorado.rma.classes.strNewRmaCaseUploadImageModalForm, function ( event ) {
                event.preventDefault();
                eldorado.rma.upload.imagePost( this );
            } );
        },
        bindingsForRmaCaseLists: function () {
            jQuery( eldorado.rma.classes.strRmaCases ).on( 'submit', eldorado.rma.classes.strRmaCasesForm, function ( event ) {
                event.preventDefault();
                let jForm = jQuery( this );
                if ( jForm.is( eldorado.rma.classes.strRmaCasesFormExternal ) === true ) {
                    eldorado.rma.handlers.listCasesPost( jForm, e4.settings.rma.case.listExternal.url );
                }
                if ( jForm.is( eldorado.rma.classes.strRmaCasesFormInternal ) === true ) {
                    eldorado.rma.handlers.listCasesPost( jForm, e4.settings.rma.case.listInternal.url );
                    if( jQuery( eldorado.rma.classes.strRmaUnassignedProductsCount).length > 0 ) {
                        eldorado.rma.handlers.countUnassignedProductsGet()
                    }
                }
            } );

            jQuery( eldorado.rma.classes.strRmaCases ).on( 'change', 'input', function ( event ) {
                event.preventDefault();
                jQuery( eldorado.rma.classes.strRmaCases ).find( eldorado.rma.classes.strRmaCasesForm ).submit();
            } );
        },
        bindingsForRmaCaseLinesLists: function () {
            jQuery( eldorado.rma.classes.strRmaCaseLines ).on( 'submit', eldorado.rma.classes.strRmaCaseLinesForm, function ( event ) {
                event.preventDefault();
                let jForm = jQuery( this );
                eldorado.rma.handlers.listCaseLinesPost( jForm, e4.settings.rma.caseLines.listInternal.url );
            } );

            jQuery( eldorado.rma.classes.strRmaCaseLines ).on( 'change', 'input', function ( event ) {
                event.preventDefault();
                jQuery( eldorado.rma.classes.strRmaCaseLines ).find( eldorado.rma.classes.strRmaCaseLinesForm ).submit();
            } );
            jQuery( eldorado.rma.classes.strRmaCaseLinesApplyConsultantModal ).on( 'submit', eldorado.rma.classes.strRmaCaseLinesApplyConsultantModalForm, function ( event ) {
                event.preventDefault();
                eldorado.rma.handlers.applyConsultantToCaseLinePost( this );
            } );
            jQuery( eldorado.rma.classes.strRmaCaseLinesApplyConsultantModal ).on( 'show.bs.modal', function ( event ) {
                let jApplyConsultantButton = jQuery( event.relatedTarget );
                jQuery( this ).find( eldorado.rma.classes.strRmaCaseLinesApplyConsultantModalFormInputCaseId ).val( jApplyConsultantButton.data( 'case-id' ) );
                jQuery( this ).find( eldorado.rma.classes.strRmaCaseLinesApplyConsultantModalFormInputCaseLineId ).val( jApplyConsultantButton.data( 'line-id' ) );
                eldorado.rma.handlers.consultantListGet( jApplyConsultantButton.data( 'case-id' ) );
            } );
            jQuery( eldorado.rma.classes.strRmaCaseLinesApplyConsultantModalForm ).on( 'change', 'input[type=radio]', function () {
                jQuery( eldorado.rma.classes.strRmaCaseLinesApplyConsultantModal ).find( eldorado.rma.classes.strRmaCaseLinesApplyConsultantModalForm ).submit();
            } );
        },
        bindingsForRmaUserChange: function () {
            jQuery( eldorado.rma.classes.strRmaChangeUserModal ).on( 'click', eldorado.rma.classes.strRmaChangeUserLink, function ( event ) {
                event.preventDefault();
                let jLink = jQuery( this );
                eldorado.rma.handlers.changeUserGet( jLink.data( 'user-id' ), jLink.data( 'user-level' ), jLink.data( 'user-name' ) );
            } );
        },
        bindingsForRmaProcessing: function () {
            let _disableReasonForRejectionModalButtonSubmit = function () {
                jQuery( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModalButtonSubmit ).attr( 'disabled', true );
            };
            let _enableReasonForRejectionModalButtonSubmit = function () {
                jQuery( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModalButtonSubmit ).removeAttr( 'disabled' );
            };
            let _resetReasonForRejectionModalForm = function () {
                jQuery( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModalForm ).trigger( 'reset' );
            };
            let _resetAllSelectedStatuses = function () {
                eldorado.rma.objCaseLinesData = {};
                _disableReasonForRejectionModalButtonSubmit();
                _resetReasonForRejectionModalForm();
                jQuery( eldorado.rma.classes.strRmaCaseDetailsStatusSelector ).each( function () {
                    jQuery( this ).val( jQuery( this ).data( 'default-value' ) );
                } );
                jQuery( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionText ).each( function () {
                    if ( jQuery( this ).parent().hasClass( 'js-new-reason' ) ) {
                        jQuery( this ).text( '' ).parent().addClass( 'd-none' );
                    }
                } );
            };
            jQuery( eldorado.rma.classes.strRmaCaseDetailsStatusSelector ).on( 'change', function ( event ) {
                event.preventDefault();
                const strIndex = jQuery( this ).data( 'index' );
                const strDefaultValue = jQuery( this ).data( 'default-value' );
                
                let objCaseLine = {
                    CaseId: jQuery( this ).data( 'case-id' ),
                    CaseLineId: jQuery( this ).data( 'case-line-id' ),
                    StatusId: parseInt(jQuery( this ).find( ':selected' ).val()),
                    ReasonForRejection: jQuery( this ).data( 'reason-for-rejection' )
                };
                if ( objCaseLine.StatusId !== parseInt(strDefaultValue)) {
                    if ( objCaseLine.StatusId === 3 ) {
                        jQuery( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModal ).data( 'index', strIndex );
                        _disableReasonForRejectionModalButtonSubmit();
                        jQuery( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModal ).modal();
                    }
                    else {
                        let jReasonForRejectionText = jQuery( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionText + '[data-index="' + strIndex + '"]' );
                        if ( jReasonForRejectionText.parent().hasClass( 'js-new-reason' ) ) {
                            jReasonForRejectionText.text( '' ).parent().addClass( 'd-none' );
                        }
                        objCaseLine.reasonForRejectionText = '';
                    }
                    eldorado.rma.objCaseLinesData[ strIndex ] = objCaseLine;
                }
                else {
                    delete eldorado.rma.objCaseLinesData[ parseInt( strIndex ) ];
                }
                eldorado.rma.validator.validateCaseDetailsSave();
            } );
            jQuery( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModal ).on( 'hide.bs.modal', function () {
                _resetReasonForRejectionModalForm();
                eldorado.rma.validator.validateCaseDetailsSave();
            } );
            jQuery( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModal ).on( 'click', eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModalButtonCancel, function () {
                _resetReasonForRejectionModalForm();
                _disableReasonForRejectionModalButtonSubmit();
                let strIndex = jQuery( this ).parents( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModal ).data( 'index' );
                let jStatusDropdown = jQuery( eldorado.rma.classes.strRmaCaseDetailsStatusSelector + '[data-index="' + strIndex + '"]' );
                delete eldorado.rma.objCaseLinesData[ parseInt( strIndex ) ];
                jStatusDropdown.val( jStatusDropdown.data( 'default-value' ) );
            } );
            jQuery( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModal ).on( 'submit', eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModalForm, function ( event ) {
                event.preventDefault();
            } );
            jQuery( eldorado.rma.classes.strRmaCaseDetailsResetButton ).on( 'click', function () {
                _resetAllSelectedStatuses();
                eldorado.rma.validator.validateCaseDetailsSave();
            } );
            jQuery( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModalSelect ).on( 'change', function () {
                jQuery( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModalTextArea ).val( jQuery( this ).val() ).trigger( 'change' );
            } );
            jQuery( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModalTextArea ).on( 'change keydown keyup', function () {
                if ( jQuery( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModalForm ).valid() ) {
                    _enableReasonForRejectionModalButtonSubmit();
                }
                else {
                    _disableReasonForRejectionModalButtonSubmit();
                }
            } );
            jQuery( eldorado.rma.classes.strRmaCaseDetailsSaveButton ).on( 'click', function () {
                if( Object.keys(eldorado.rma.objCaseLinesData).length > 0 ){
                    eldorado.rma.handlers.updateRmaLinesToCasePost();
                }
            });
            jQuery( eldorado.rma.classes.strRmaCaseDetailsCloseButton ).on( 'click', function () {
                let strCaseUrl = jQuery( this ).data( 'case-url' ),
                    strCaseId = jQuery( this ).data( 'case-id' );
                eldorado.rma.handlers.closeRmaCaseGet( strCaseUrl, strCaseId );
            } );
        },
        validator: {
            validatedForm: null,
            validateForm: function ( domForm ) {
                let jForm = jQuery( domForm );
                return jForm.validate( {
                    ignore: '.ignore',
                    focusInvalid: false,
                    submitHandler: function ( form ) {
                        if ( jForm.is( eldorado.rma.classes.strNewRmaCaseModalCreateRmaLineForm ) === true ) {
                            eldorado.rma.handlers.addRmaLineToCasePost( form );
                        }
                        if ( jForm.is( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModalForm ) === true ) {
                            let intIndex = parseInt( jForm.parents( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModal ).data( 'index' ) );
                            eldorado.rma.objCaseLinesData[ intIndex ].ReasonForRejection = jQuery( form ).find( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModalTextArea ).val();
                            jQuery( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionText + '[data-index="' + intIndex + '"]' ).text( eldorado.rma.objCaseLinesData[ intIndex ].ReasonForRejection ).parent().removeClass( 'd-none' );
                            jQuery( eldorado.rma.classes.strRmaCaseDetailsReasonForRejectionModal ).modal( 'hide' );
                            eldorado.rma.validator.validatedForm.resetForm();
                        }
                    }
                } );
            },
            validationCustomRules: function () {
                jQuery.validator.addMethod( 'disallowHtml', function ( value, element ) {
                    return !( this.optional( element ) || /<("[^"]*"|'[^']*'|[^'">])*>/.test( value ) );
                }, 'Ugyldig indhold' );
                jQuery.validator.addClassRules( "disallow-html", {
                    disallowHtml: true
                } );
            },
            validateNewCaseConfirmation: function () {
                if ( eldorado.rma.arrCaseLinesData.length > 0 && jQuery( eldorado.rma.classes.strNewRmaCaseConfirmCheckbox ).is( ':checked' ) ) {
                    jQuery( eldorado.rma.classes.strNewRmaCaseConfirmButton ).removeAttr( 'disabled' );
                }
                else {
                    jQuery( eldorado.rma.classes.strNewRmaCaseConfirmButton ).attr( 'disabled', true );
                }
            },
            validateCaseDetailsSave: function () {
                if ( Object.keys(eldorado.rma.objCaseLinesData).length > 0 ) {
                    jQuery( eldorado.rma.classes.strRmaCaseDetailsSaveButton ).removeAttr( 'disabled' );
                }
                else {
                    jQuery( eldorado.rma.classes.strRmaCaseDetailsSaveButton ).attr( 'disabled', true );
                }
            }
        },
        handlers: {
            addRmaLineToCasePost: function ( form ) {
                let objFormData = Object.fromEntries( new FormData( form ).entries() );
                jQuery.ajax( {
                    url: e4.settings.rma.case.addLine.url,
                    method: 'POST',
                    dataType: 'json',
                    cache: false,
                    data: JSON.stringify( objFormData ),
                    contentType: "application/json",
                    beforeSend: function () {
                        jQuery( eldorado.rma.classes.strNewRmaCaseModalStep2 ).find( eldorado.rma.classes.strRmaCaseOverlay ).addClass( 'is-loading' );
                    }
                } ).done( function ( jsonData ) {
                    if ( jsonData.Success === true && jsonData.Data !== undefined ) {
                        eldorado.rma.arrCaseLinesData.push( Object.assign( objFormData, { CaseLineId: jsonData.Data } ) );
                        jQuery( eldorado.rma.classes.strNewRmaCaseLines ).html( e4.handlebars.tmpl.eldoradoNewRmaCaseLines( eldorado.rma.arrCaseLinesData ) );
                        jQuery( eldorado.rma.classes.strNewRmaCaseModalStep2 ).find( eldorado.rma.classes.strRmaCaseOverlay ).removeClass( 'is-loading' );
                        eldorado.rma.validator.validateNewCaseConfirmation();
                        jQuery( eldorado.rma.classes.strNewRmaCaseModal ).modal( 'hide' );
                    }
                    else {
                        alert( 'Der skete en fejl: ' + jsonData.ErrorMsg );
                    }
                } );
            },
            deleteRmaLineFromCaseGet: function ( caseLineIndex, caseLineId ) {
                jQuery.ajax( {
                    url: e4.settings.rma.case.deleteLine.url,
                    method: 'GET',
                    dataType: 'json',
                    cache: false,
                    data: {
                        rmaCaseLineId: caseLineId
                    },
                    contentType: "application/json",
                    beforeSend: function () {
                        jQuery( eldorado.rma.classes.strNewRmaCaseLinesDeleteConfirmationModal ).find( eldorado.rma.classes.strRmaCaseOverlay ).addClass( 'is-loading' );
                    }
                } ).done( function ( jsonData ) {
                    if ( jsonData.Success === true ) {
                        eldorado.rma.arrCaseLinesData.splice( caseLineIndex, 1 );
                        jQuery( eldorado.rma.classes.strNewRmaCaseLines ).html( e4.handlebars.tmpl.eldoradoNewRmaCaseLines( eldorado.rma.arrCaseLinesData ) );
                        eldorado.rma.validator.validateNewCaseConfirmation();
                        jQuery( eldorado.rma.classes.strNewRmaCaseLinesDeleteConfirmationModal ).modal( 'hide' );
                    }
                    else {
                        alert( 'Der skete en fejl: ' + jsonData.ErrorMsg );
                    }
                } );
            },
            updateRmaLinesToCasePost: function () {
                const arrCaseLinesData = Object.keys(eldorado.rma.objCaseLinesData).map(function (key) { return eldorado.rma.objCaseLinesData[key]; })
                jQuery.ajax( {
                    url: e4.settings.rma.case.updateLines.url,
                    method: 'POST',
                    dataType: 'json',
                    cache: false,
                    data: JSON.stringify(arrCaseLinesData),
                    contentType: "application/json",
                    beforeSend: function () {
                        jQuery( eldorado.rma.classes.strRmaCaseDetailsSaveButton ).attr( 'disabled', true ).parent().find( eldorado.rma.classes.strRmaCaseOverlay ).addClass( 'is-loading' );
                        jQuery( eldorado.rma.classes.strRmaCaseDetailsStatusSelector ).attr( 'disabled', true );
                    }
                } ).done( function ( jsonData ) {
                    if ( jsonData.Success === true ) {
                        location.reload();
                    }
                    else {
                        alert( 'Der skete en fejl: ' + jsonData.ErrorMsg );
                    }
                } );
            },
            confirmRmaCaseGet: function ( caseUrl, caseId ) {
                jQuery.ajax( {
                    url: e4.settings.rma.case.confirm.url,
                    method: 'GET',
                    dataType: 'json',
                    cache: false,
                    data: {
                        caseId: caseId
                    },
                    contentType: "application/json",
                    beforeSend: function () {
                        jQuery( eldorado.rma.classes.strNewRmaCase ).find( eldorado.rma.classes.strRmaCaseOverlay ).addClass( 'is-loading' );
                    }
                } ).done( function ( jsonData ) {
                    if ( jsonData.Success === true ) {
                        window.location.href = caseUrl + '?caseid=' + caseId;
                    }
                    else {
                        alert( 'Der skete en fejl: ' + jsonData.ErrorMsg );
                    }
                } );
            },
            closeRmaCaseGet: function ( caseUrl, caseId ) {
                jQuery.ajax( {
                    url: e4.settings.rma.case.close.url,
                    method: 'GET',
                    dataType: 'json',
                    cache: false,
                    data: {
                        caseId: caseId
                    },
                    contentType: "application/json",
                    beforeSend: function () {
                        jQuery( eldorado.rma.classes.strRmaCaseDetailsCloseButton ).attr( 'disabled', true ).parent().find( eldorado.rma.classes.strRmaCaseOverlay ).addClass( 'is-loading' );
                    }
                } ).done( function ( jsonData ) {
                    if ( jsonData.Success === true ) {
                        window.location.href = caseUrl;
                    }
                    else {
                        alert( 'Der skete en fejl: ' + jsonData.ErrorMsg );
                    }
                } );
            },
            listCasesPost: function ( jForm, url ) {
                let boolHasActivePage = false;
                jQuery.ajax( {
                    url: url,
                    method: 'POST',
                    dataType: 'json',
                    cache: false,
                    data: jForm.serialize()
                } ).done( function ( jsonData ) {
                    jQuery( eldorado.rma.classes.strRmaCasesList ).html( e4.handlebars.tmpl.eldoradoRmaCasesList( jsonData ) );
                    jQuery( eldorado.rma.classes.strRmaCases ).find( eldorado.rma.classes.strRmaCount ).text( jsonData.RmaCasesCount );
                    jQuery( eldorado.rma.classes.strRmaCasesList ).find( eldorado.rma.classes.strRmaListPaginationPage ).each( function () {
                        if ( !boolHasActivePage && jQuery( this ).is( ':checked' ) ) {
                            boolHasActivePage = true;
                            return false;
                        }
                    } );
                    if ( !boolHasActivePage && jQuery( eldorado.rma.classes.strRmaCasesList ).find( eldorado.rma.classes.strRmaListPaginationPage ).length > 0 ) {
                        jQuery( eldorado.rma.classes.strRmaCases ).find( eldorado.rma.classes.strRmaCasesForm ).submit();
                    }
                } );
            },
            listCaseLinesPost: function ( jForm, url ) {
                let boolHasActivePage = false;
                jQuery.ajax( {
                    url: url,
                    method: 'POST',
                    dataType: 'json',
                    cache: false,
                    data: jForm.serialize()
                } ).done( function ( jsonData ) {
                    jQuery( eldorado.rma.classes.strRmaCaseLinesList ).html( e4.handlebars.tmpl.eldoradoRmaCaseLinesList( jsonData ) );
                    jQuery( eldorado.rma.classes.strRmaCaseLines ).find( eldorado.rma.classes.strRmaCount ).text( jsonData.RmaCaseLinesCount );
                    jQuery( eldorado.rma.classes.strRmaCaseLinesList ).find( eldorado.rma.classes.strRmaListPaginationPage ).each( function () {
                        if ( !boolHasActivePage && jQuery( this ).is( ':checked' ) ) {
                            boolHasActivePage = true;
                            return false;
                        }
                    } );
                    if ( !boolHasActivePage && jQuery( eldorado.rma.classes.strRmaCaseLinesList ).find( eldorado.rma.classes.strRmaListPaginationPage ).length > 0 ) {
                        jQuery( eldorado.rma.classes.strRmaCaseLines ).find( eldorado.rma.classes.strRmaCaseLinesForm ).submit();
                    }
                } );
            },
            countUnassignedProductsGet: function () {
                jQuery.ajax( {
                    url: e4.settings.rma.caseLines.listInternal.url,
                    method: 'GET',
                    dataType: 'json',
                    cache: false
                } ).done( function ( jsonData ) {
                    jQuery( eldorado.rma.classes.strRmaCases ).find( eldorado.rma.classes.strRmaUnassignedProductsCount ).text( jsonData.RmaCaseLinesCount );
                } );
            },
            changeUserGet: function ( userId, userLevel, userName ) {
                jQuery.ajax( {
                    url: e4.settings.rma.user.impersonate.url,
                    method: 'GET',
                    dataType: 'json',
                    cache: false,
                    data: {
                        UserId: userId,
                        Level: userLevel,
                        Name: userName
                    },
                    contentType: "application/json",
                    beforeSend: function () {
                        jQuery( eldorado.rma.classes.strRmaChangeUserModal ).find( eldorado.rma.classes.strRmaCaseOverlay ).addClass( 'is-loading' );
                    }
                } ).done( function () {
                    location.reload();
                } );
            },
            consultantListGet: function ( caseId ) {
                jQuery.ajax( {
                    url: e4.settings.rma.user.consultants.url,
                    method: 'GET',
                    dataType: 'json',
                    cache: false,
                    data: {
                        CaseId: caseId
                    },
                    contentType: "application/json",
                    beforeSend: function () {
                        jQuery( eldorado.rma.classes.strRmaCaseLinesApplyConsultantModal ).find( eldorado.rma.classes.strRmaCaseOverlay ).addClass( 'is-loading' );
                    }
                } ).done( function ( jsonData ) {
                    jQuery( eldorado.rma.classes.strRmaCaseLinesApplyConsultantModal ).find( eldorado.rma.classes.strRmaCaseOverlay ).removeClass( 'is-loading' );
                    jQuery( eldorado.rma.classes.strRmaCaseLinesApplyConsultantList ).html( e4.handlebars.tmpl.eldoradoRmaCaseLineConsultants( jsonData ) );
                } );
            },
            applyConsultantToCaseLinePost: function ( form ) {
                let objFormData = Object.fromEntries( new FormData( form ).entries() );
                jQuery.ajax( {
                    url: e4.settings.rma.case.updateLine.url,
                    method: 'POST',
                    dataType: 'json',
                    cache: false,
                    data: JSON.stringify( objFormData ),
                    contentType: "application/json",
                    beforeSend: function () {
                        jQuery( eldorado.rma.classes.strRmaCaseLinesApplyConsultantModal ).find( eldorado.rma.classes.strRmaCaseOverlay ).addClass( 'is-loading' );
                    }
                } ).done( function ( jsonData ) {
                    if ( jsonData.Success === true && jsonData.Data !== undefined ) {
                        jQuery( eldorado.rma.classes.strRmaCaseLinesApplyConsultantModal ).modal( 'hide' );
                        jQuery( eldorado.rma.classes.strRmaCaseLines ).find( eldorado.rma.classes.strRmaCaseLinesForm ).submit();
                    }
                    else {
                        alert( 'Der skete en fejl: ' + jsonData.ErrorMsg );
                    }
                } );
            }
        },
        upload: {
            objReceiptData: {},
            objImageData: {},
            receiptPost: function ( form ) {
                jQuery.ajax( {
                    url: e4.settings.rma.upload.url,
                    method: 'POST',
                    dataType: 'json',
                    contentType: false,
                    processData: false,
                    cache: false,
                    data: new FormData( form ),
                    beforeSend: function () {
                        jQuery( eldorado.rma.classes.strNewRmaCaseUploadReceiptModal ).find( eldorado.rma.classes.strRmaCaseOverlay ).addClass( 'is-loading' );
                        jQuery( eldorado.rma.classes.strNewRmaCaseUploadReceiptModalFormSubmit ).attr( 'disabled', true );
                    }
                } ).done( function ( jsonData ) {
                    eldorado.rma.upload.objReceiptData = jsonData;
                    jQuery( eldorado.rma.classes.strNewRmaCaseUploadReceiptModal ).find( eldorado.rma.classes.strRmaCaseOverlay ).removeClass( 'is-loading' );
                    if ( eldorado.rma.upload.objReceiptData.success === true ) {
                        jQuery( eldorado.rma.classes.strNewRmaCaseModalReceiptInput ).val( eldorado.rma.upload.objReceiptData.fileName );
                        jQuery( eldorado.rma.classes.strNewRmaCaseModalReceiptInputHidden ).val( eldorado.rma.upload.objReceiptData.fullPath ).valid();
                        jQuery( eldorado.rma.classes.strNewRmaCaseUploadReceiptModalFormSubmit ).attr( 'disabled', true );
                        jQuery( eldorado.rma.classes.strNewRmaCaseUploadReceiptModal ).modal( 'hide' );
                    }
                    else {
                        jQuery( eldorado.rma.classes.strNewRmaCaseUploadReceiptModalFileInputLabel ).html( eldorado.rma.upload.objReceiptData.message ).addClass( 'text-danger' );
                        jQuery( eldorado.rma.classes.strNewRmaCaseUploadReceiptModalFormSubmit ).attr( 'disabled', true );
                    }
                } );
            },
            imagePost: function ( form ) {
                jQuery.ajax( {
                    url: e4.settings.rma.upload.url,
                    method: 'POST',
                    dataType: 'json',
                    contentType: false,
                    processData: false,
                    cache: false,
                    data: new FormData( form ),
                    beforeSend: function () {
                        jQuery( eldorado.rma.classes.strNewRmaCaseUploadImageModal ).find( eldorado.rma.classes.strRmaCaseOverlay ).addClass( 'is-loading' );
                        jQuery( eldorado.rma.classes.strNewRmaCaseUploadImageModalFormSubmit ).attr( 'disabled', true );
                    }
                } ).done( function ( jsonData ) {
                    eldorado.rma.upload.objImageData = jsonData;
                    jQuery( eldorado.rma.classes.strNewRmaCaseUploadImageModal ).find( eldorado.rma.classes.strRmaCaseOverlay ).removeClass( 'is-loading' );
                    if ( eldorado.rma.upload.objImageData.success === true ) {
                        jQuery( eldorado.rma.classes.strNewRmaCaseModalImageInput ).val( eldorado.rma.upload.objImageData.fileName );
                        jQuery( eldorado.rma.classes.strNewRmaCaseModalImageInputHidden ).val( eldorado.rma.upload.objImageData.fullPath ).valid();
                        jQuery( eldorado.rma.classes.strNewRmaCaseUploadImageModalFormSubmit ).attr( 'disabled', true );
                        jQuery( eldorado.rma.classes.strNewRmaCaseUploadImageModal ).modal( 'hide' );
                    }
                    else {
                        jQuery( eldorado.rma.classes.strNewRmaCaseUploadImageModalFileInputLabel ).html( eldorado.rma.upload.objImageData.message ).addClass( 'text-danger' );
                        jQuery( eldorado.rma.classes.strNewRmaCaseUploadImageModalFormSubmit ).attr( 'disabled', true );
                    }
                } );
            }
        },
        search: {
            orderlines: {
                objData: [],
                get: function ( domNode ) {
                    jQuery.ajax( {
                        url: e4.settings.rma.orderlines.url,
                        method: 'GET',
                        dataType: 'json',
                        cache: false,
                        beforeSend: function () {
                            jQuery( eldorado.rma.classes.strNewRmaCaseModalStep1 ).find( eldorado.rma.classes.strRmaCaseOverlay ).addClass( 'is-loading' );
                        },
                        data: {
                            searchQuery: jQuery.trim( domNode.value )
                        }
                    } ).done( function ( jsonData ) {
                        eldorado.rma.search.orderlines.objData = jsonData;
                        jQuery( eldorado.rma.classes.strNewRmaCaseModalOrderlinesResults ).html( e4.handlebars.tmpl.eldoradoNewRmaCaseOrderlinesResults( eldorado.rma.search.orderlines.objData ) );
                        jQuery( eldorado.rma.classes.strNewRmaCaseModalInitialAlert ).addClass( 'd-none' );
                        jQuery( eldorado.rma.classes.strNewRmaCaseModalStep1 ).find( eldorado.rma.classes.strRmaCaseOverlay ).removeClass( 'is-loading' );
                        if ( eldorado.rma.search.orderlines.objData.length === 0 ) {
                            jQuery( eldorado.rma.classes.strNewRmaCaseModalOrderlinesInput ).focus();
                        }
                    } );
                }
            }
        },
        reset: function () {
            jQuery( eldorado.rma.classes.strNewRmaCaseModalStep1 ).removeClass( 'd-none' );
            jQuery( eldorado.rma.classes.strNewRmaCaseModalStep2 ).addClass( 'd-none' );

            jQuery( eldorado.rma.classes.strNewRmaCaseModalInitialAlert ).removeClass( 'd-none' );

            jQuery( eldorado.rma.classes.strNewRmaCaseModalOrderlinesResults ).html( '' );
            jQuery( eldorado.rma.classes.strNewRmaCaseModalOrderlinesResultsSelection ).html( '' );
            jQuery( eldorado.rma.classes.strNewRmaCaseModalOrderlinesInput ).val( '' );

            jQuery( eldorado.rma.classes.strNewRmaCaseModalCreateRmaLineFormButton ).attr( 'disabled', true );
            jQuery( eldorado.rma.classes.strNewRmaCaseModalCreateRmaLineForm ).trigger( 'reset' );

            jQuery( eldorado.rma.classes.strNewRmaCaseModalReceiptInputHidden ).val( '' );
            jQuery( eldorado.rma.classes.strNewRmaCaseModalImageInputHidden ).val( '' );

            jQuery( eldorado.rma.classes.strNewRmaCaseUploadReceiptModalFileInput ).val( '' );
            jQuery( eldorado.rma.classes.strNewRmaCaseUploadReceiptModalFileInputLabel ).html( jQuery( eldorado.rma.classes.strNewRmaCaseUploadReceiptModalFileInputLabel ).data( 'default-text' ) );
            jQuery( eldorado.rma.classes.strNewRmaCaseUploadImageModalFileInput ).val( '' );
            jQuery( eldorado.rma.classes.strNewRmaCaseUploadImageModalFileInputLabel ).html( jQuery( eldorado.rma.classes.strNewRmaCaseUploadImageModalFileInputLabel ).data( 'default-text' ) );
            eldorado.rma.validator.validatedForm.resetForm();
        }
    };
}() );
